import { call, delay, put, select } from 'redux-saga/effects';
import get from 'lodash.get';

// @ts-ignore
import { submittingSelectors } from 'shared';

// Actions
// @ts-ignore
import setHash from 'services/hashes';

// Selectors
// @ts-ignore
import { selectIsOnline } from 'services/connection/selectors';
// @ts-ignore
import { makeSelectHash } from 'services/hashes/selectors';

// Utils
// @ts-ignore
import axiosRetry from 'utils/axiosRetry';

const DEFAULT_INTERVAL_MS = 120000;

interface Parameters {
    config: any;
    succeeded: any;
    failed: any;
    persistOffline?: boolean;
    intervalMs?: number;
}

export default function* axiosPoll({
    config,
    succeeded,
    failed,
    persistOffline,
    intervalMs = DEFAULT_INTERVAL_MS
}: Parameters): any {
    // When polling first starts, use existing hash if one exists.
    let hash = yield select(makeSelectHash(config.url));

    while (true) {
        // Select Is Online
        const isOnline = yield select(selectIsOnline);

        // Select Is Submitting
        const isSubmitting = yield select(
            submittingSelectors.selectIsSubmitting()
        );

        // Select Hash
        let hashMatch = false;

        if (!hash || (hash && isOnline && !isSubmitting)) {
            try {
                if (hash) {
                    const hashResponse = yield call(axiosRetry, {
                        ...config,
                        params: {
                            ...(config && config.params ? config.params : {}),
                            hash: true
                        }
                    });

                    hashMatch = hash === get(hashResponse, 'headers.x-hash');
                }
                if (!hashMatch) {
                    const response = yield call(axiosRetry, config);

                    hash = get(response, 'headers.x-hash');

                    /**
                     * If we are storing the requested data offline,
                     * we need to store the resulting hash so that it can be checked.
                     */
                    if (persistOffline) {
                        yield put(setHash(config.url, hash));
                    }

                    yield call(succeeded, response);
                }
            } catch (error) {
                yield call(failed, error);
            }
        }

        yield delay(intervalMs);
    }
}
